import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';

import { Config } from 'src/app/config/config';

@Injectable()
export class UtilitiesService {

  private whilePromise = (
    condition: () => Promise<boolean>,
    action: () => Promise<boolean>
  ) => {
    condition().then(value => {
      if (value) {
        action().then(closed => {
          if (closed) {
            this.whilePromise(condition, action);
          } else {
            // throw new Error("Could not dismiss the topmost loader. Aborting...");
          }
        });
      }
    });
  };

  constructor(
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private http: HttpClient,
    private config: Config
  ) {
  }

  async isConnected(method = 'head') {
    return new Promise((resolve, reject) => {
      let url = new URL(this.config.apiUrl);
      let domain = `${url.protocol}//${url.host}`;

      if (method == 'head') {
        this.http.head(`${domain}/?rand=` + Math.floor((1 + Math.random()) * 0x10000))
        .subscribe((data:any) => {
          resolve(true);
        }, err => {
          reject(err);
        })
      } else {
        this.http.get(`${domain}/?rand=` + Math.floor((1 + Math.random()) * 0x10000))
        .subscribe((data:any) => {
          resolve(data.uuid);
        }, err => {
          reject(err);
        })
      }
    });
  }

  async showAlert(cssClass, message, buttons, title = null, inputs = null) {
    this.dismissLoaders();

    let params = {
      header: title,
      message: message,
      buttons: buttons,
      cssClass: `app-alert ${cssClass ? cssClass : (!cssClass && !title ? 'success' : '')}`
    }

    if (inputs != null) {
      params['inputs'] = inputs;
    }

    const update = await this.alertCtrl.create(params);

    await update.present();
  }

  async showLoader(message:string = '') {
    (await (await this.loadingCtrl.create({ message: message }))).present()
  }

  dismissLoaders() {
    this.whilePromise(() => this.loadingCtrl.getTop().then(topLoader => topLoader != null), () => this.loadingCtrl.dismiss());
  }
}